import { render, staticRenderFns } from "./PFormInputText.vue?vue&type=template&id=226cb50f&scoped=true"
import script from "./PFormInputText.vue?vue&type=script&lang=ts"
export * from "./PFormInputText.vue?vue&type=script&lang=ts"
import style0 from "./PFormInputText.vue?vue&type=style&index=0&id=226cb50f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226cb50f",
  null
  
)

export default component.exports